import fetch from 'commons/src/api/fetch';
import getFetchHeaders from 'commons/src/api/getFetchHeaders';

export default async (): Promise<{ embeddingUrl: string }> =>
    fetch<{ embeddingUrl: string }>('/quicksight/energy', {
        method: 'GET',
        headers: await getFetchHeaders(),
    });
